import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { PASSWORD_RULES, getPasswordChecks } from "../../utils/passwordValidation";
import "./PasswordRequirements.scss";

// Live checklist for the shared password rules (see utils/passwordValidation).
// Reusable anywhere a new password is being set, not just registration.
const PasswordRequirements = ({ password }) => {
  const checks = getPasswordChecks(password);

  return (
    <div className="password-requirements">
      <span className="password-requirements_label">
        Password must include a combination of:
      </span>
      <div className="password-requirements_list">
        {PASSWORD_RULES.map(({ key, label }) => (
          <span
            key={key}
            className={`password-requirements_item${checks[key] ? " is-met" : ""}`}
          >
            <CheckCircleIcon fontSize="inherit" />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PasswordRequirements;
